import React from 'react';
import {Box, Input, InputLabel, MenuItem, FormControl, Select} from '@mui/material';

export default function SelectDropDown({style, id , borderColor, disabled,options,value,onChange,name,label,sx,Default,MenuProps, defaultlabel, placeholder}) {
  return (
    <Box sx={{ minWidth: 120}}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{defaultlabel}</InputLabel>
        <Select
          id={id}
          sx={{...sx}}
          labelId="demo-simple-select-label"
          value={value}
          onChange={onChange}
          name={name}
          label={label}
          size='small'
          displayEmpty
          defaultValue={Default}
          disabled ={disabled}
          MenuProps={MenuProps}
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{color:'gray',fontSize:'14px', fontWeight:'normal'}}>{placeholder}</span>;
            }
            const selectedOption = options?.find((option) => option.value === selected);
            return <span style={{ color: selectedOption?.color, hover:'rgba(0, 0, 0, 0.3'}}>{selectedOption?.label}</span>;
          }}
        >
           <MenuItem disabled value="">
            <span style={{color:'gray', fontSize:'14px', fontWeight:'normal'}}>{placeholder}</span>
          </MenuItem>
          {
            options?.map((item)=>{
              return <MenuItem value={item.value} style={{ color:item.color || '#000' }}>{item.label}</MenuItem>
            })
          }
        </Select>
      </FormControl>
    </Box>
  );
}